// import { useMemo } from "react";
// import { SubscriptionCard } from "../subscription/SubscriptionCard";
// import { Subscriptions } from "../../../const/subscriptions";
import { makeStyles, createStyles, Grid } from "@material-ui/core";
// import { ChevronRight } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import FormWizardButtons from "../../../yoello-lib/modules/dynamicForms/FormWizardButtons";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { Trans } from "react-i18next";
import { IVenueData } from "../types";


const useStyles = makeStyles((theme) =>
    createStyles({
        text: {
            marginBottom: "1rem"
        },
        subscription: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        bottomRow: {
            marginTop: '1rem',
        },
    }))

interface IGetStartedProps {
    setSubscription: (id: string) => void;
    onBack?: () => void;
    venueData?: Partial<IVenueData>;
    signupTextKey: string;
}

export function GetStartedComponent({
    setSubscription,
    onBack,
    venueData,
    signupTextKey
}: IGetStartedProps) {
    // const [selected, setSelected] = useState(false);
    // const sub = useMemo(() => {
    //     if (!venueData) return;
    //     const code = venueData?.venue_location?.value
    //     //@ts-ignore
    //     return Subscriptions[code][0];
    // }, [venueData])
    const classes = useStyles();
    const { t } = useTranslation();
    // function getStartedClick() {
    //     setSubscription(sub.id)
    // }
    return <div>
        <div className={classes.text}>
            <Trans i18nKey={signupTextKey}>
                0<b>1</b>2
            </Trans>
        </div>
        {/* <div className={classes.text}>
            {t('signup.newVenue.getStarted3')}
        </div> */}
        {/* <div className={classes.subscription}>
            <SubscriptionCard {...sub} active={selected} isLarge={true}
                onClick={() => setSelected((prevState) => {
                    return !prevState
                })} />
        </div> */}
        <Grid className={classes.bottomRow} container spacing={3}>
            <FormWizardButtons
                leftButton={onBack ? {
                    label: t('signup.newVenue.backToVenueList'), type: "button",
                    color: EColourPanel.DEFAULT, onClick: onBack
                } : undefined}
                // rightButton={{
                //     type: 'button', label: t('signup.newVenue.getStartedButton'), endIcon: <ChevronRight />,
                //     color: EColourPanel.PRIMARY, onClick: getStartedClick, disabled: !selected
                // }}
            />
        </Grid>
    </div>
}